import { createContext, useContext } from "react";
import { CONTACT } from "@/config/siteConfig";

export const SiteSettings = createContext({ site: null, refresh: () => {} });
export const useSiteSettings = () => useContext(SiteSettings);

export const apiImg = (path) => `${process.env.REACT_APP_BACKEND_URL}/api/uploads/${path}`;

export const telHref = (num) => `tel:+91${String(num).replace(/\D/g, "").slice(-10)}`;

export const DEFAULT_PHONES = [
  { id: "cfg-1", number: CONTACT.phoneDisplay },
  { id: "cfg-2", number: CONTACT.phone2Display },
];

export const getPhones = (site) => (site?.phones?.length ? site.phones : DEFAULT_PHONES);
export const getWaNumber = (site) => site?.whatsappNumber || CONTACT.whatsappNumber;
export const getEmail = (site) => site?.email || CONTACT.email;
export const getAddress = (site) => site?.address || CONTACT.address;
